module.exports = __webpack_public_path__ + "img/logo_safety.433e63e7.jpg";